import moment from 'moment'

function formatDwellTime (dwellTime) {
  let date = moment(dwellTime, 'HH:mm')
  let hours = date.hours()
  let minutes = date.minutes()
  return (hours * 60 + minutes) * 60
}

function filterParams(params) {
  var newPar = {}
  for (var key in params) {
    if (params[key] && params[key].toString().replace(/(^\s*)|(\s*$)/g, '') !== '') {
      newPar[key] = params[key]
    }
  }
  return newPar
}

export class Waypoint {

  constructor(type, info) {
    this.type = type
    this.info = info
    this.lat = info.latitude
    this.lng = info.longitude
  }

  // 适用于Waypoint.TYPE.VIA
  setWaypointOptions() {
    let obj = {}
    let str = ''
    if(this.type === Waypoint.TYPE.VIA) {
      obj.stopDuration = this.info.dwellTime ? formatDwellTime(this.info.dwellTime) : ''
      obj = filterParams(obj)
    }
    Object.keys(obj).map(item => {
      str += `${item}=${obj[item]}&`
    })
    return str
  }

  toQueryParamString() {
    let prefix = ''
    let str = this.setWaypointOptions()
    switch (this.type) {
      case Waypoint.TYPE.START:
        prefix = 'origin'
        break
      case Waypoint.TYPE.STOP:
        prefix = 'destination'
        break;
      case Waypoint.TYPE.VIA:
        prefix = 'via'
        break
      default:
        throw Error(`Type: ${this.type} is unknown`)
    }
    if (!this.lat || !this.lng) throw Error('waypoints have no latitude and longitude')
    return str ? `${prefix}=${this.lat},${this.lng}!${str}` : `${prefix}=${this.lat},${this.lng}`
  }
}

Waypoint.TYPE = {START: 'start', STOP: 'stop', VIA: 'via'}
